import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { useState, useEffect } from 'react';
import { UnifiedMapControls } from './components/MapControls';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Fix default icon issue with Leaflet in Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const DEFAULT_POSITION = { lat: 32.08, lng: 34.78 };

export const LocationPicker = ({ onLocationSelect, initialLocation, onLoad, updateOnInitialLocation=false }) => {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (initialLocation && initialLocation.lat && initialLocation.lng) {
            setPosition(initialLocation);
        } else {
            // Try to use geolocation
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (pos) => {
                        const { latitude, longitude } = pos.coords;
                        const userPosition = { lat: latitude, lng: longitude };
                        setPosition(userPosition);
                        if (updateOnInitialLocation) onLocationSelect(userPosition);
                    },
                    () => {
                        // On error or denial, fall back to default
                        setPosition(DEFAULT_POSITION);
                    }
                );
            } else {
                // Geolocation not supported
                setPosition(DEFAULT_POSITION);
            }
        }
    }, [initialLocation]);

    const MapClickHandler = () => {
        useMapEvents({
            click(e) {
                const { lat, lng } = e.latlng;
                setPosition({ lat, lng });
                onLocationSelect({ lat, lng });
            },
        });
        return null;
    };

    if (!position) return null; // render nothing until position is set


    return (
        <MapContainer
            center={[position.lat, position.lng]}
            zoom={13}
            scrollWheelZoom={true}
            style={{ height: '100%', width: '100%', borderRadius: '12px' }}
            whenCreated={(map) => {
                map.on('load', () => {
                    if (onLoad) onLoad(); // ✅ Fires after tiles are rendered
                });
            }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="&copy; OpenStreetMap contributors"
            />
            <MapClickHandler />
            <Marker position={[position.lat, position.lng]}/>

            {/* Modern map controls - with layer switcher */}
            <UnifiedMapControls userLocation={[position.lat, position.lng]} showLayerSwitcher={true} />
        </MapContainer>
    );
};
